import { render } from "./DisabledAccountModal.vue?vue&type=template&id=5a2760d0"
import script from "./DisabledAccountModal.vue?vue&type=script&lang=js"
export * from "./DisabledAccountModal.vue?vue&type=script&lang=js"

import "./DisabledAccountModal.vue?vue&type=style&index=0&id=5a2760d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__